import { ICD9Procedure, ICD9ProcedureQuery } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { StrongText, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

export const createIcd9ProceduresSearchCreator = (dictionaryValidOn: Date) => {
   return (searchText: string | null) => {
      return async (): CqrsQueryPerformResult<ICD9Procedure[]> =>
         performCqrsQuerySearch<ICD9Procedure>(() => {
            const query = new ICD9ProcedureQuery();
            query.codeOrName = TextPattern.anywhereIgnoreCase(searchText ?? undefined);
            query.dictionaryValidOn = dictionaryValidOn;
            return query;
         });
   };
};

export const procedureLabelExtractor = (procedure: ICD9Procedure): string => procedure.name;

export const itemRenderer = (item: ICD9Procedure): JSX.Element => {
   return (
      <TextSeparator separator={TextSeparatorType.SPACE}>
         <StrongText testId={'name'}>{item.name}</StrongText>
         <Text testId={'code'}>{`(${item.code})`}</Text>
      </TextSeparator>
   );
};
